var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var isKeyRejected = false;
var attachedDetachers = new Set();
window.gm_authFailure = function () {
    isKeyRejected = true;
    attachedDetachers.forEach(function (detach) { return detach(); });
    attachedDetachers.clear();
};
var PROBE_TIMEOUT_MS = 8000;
var SCRIPT_WAIT_TIMEOUT_MS = 10000;
var SCRIPT_POLL_MS = 150;
var usabilityPromise = null;
var isPlacesScriptReady = function () { var _a, _b, _c; return Boolean(((_c = (_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.places) === null || _c === void 0 ? void 0 : _c.Autocomplete) && window.google.maps.places.AutocompleteService); };
var waitForPlacesScript = function () {
    return new Promise(function (resolve) {
        if (isPlacesScriptReady()) {
            resolve(true);
            return;
        }
        var deadline = Date.now() + SCRIPT_WAIT_TIMEOUT_MS;
        var pollTimer = window.setInterval(function () {
            if (isPlacesScriptReady()) {
                window.clearInterval(pollTimer);
                resolve(true);
                return;
            }
            if (isKeyRejected || Date.now() > deadline) {
                window.clearInterval(pollTimer);
                resolve(false);
            }
        }, SCRIPT_POLL_MS);
    });
};
var probePlaces = function () {
    return waitForPlacesScript().then(function (isScriptReady) {
        if (!isScriptReady || isKeyRejected) {
            return false;
        }
        return new Promise(function (resolve) {
            var _a, _b, _c;
            var Service = (_c = (_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.places) === null || _c === void 0 ? void 0 : _c.AutocompleteService;
            if (!Service) {
                resolve(false);
                return;
            }
            var isSettled = false;
            var settle = function (isUsable) {
                if (!isSettled) {
                    isSettled = true;
                    resolve(isUsable);
                }
            };
            var probeTimer = window.setTimeout(function () { return settle(false); }, PROBE_TIMEOUT_MS);
            try {
                new Service().getPlacePredictions(__assign({ input: 'main' }, AUTOCOMPLETE_OPTIONS), function (_predictions, status) {
                    window.clearTimeout(probeTimer);
                    settle(status === 'OK' || status === 'ZERO_RESULTS');
                });
            }
            catch (error) {
                window.clearTimeout(probeTimer);
                settle(false);
            }
        });
    });
};
export var isPlacesUsable = function () {
    if (!usabilityPromise) {
        usabilityPromise = probePlaces().then(function (isUsable) {
            if (!isUsable && !isKeyRejected && !isPlacesScriptReady()) {
                usabilityPromise = null;
            }
            return isUsable;
        });
    }
    return usabilityPromise;
};
var AUTOCOMPLETE_OPTIONS = {
    componentRestrictions: { country: ['us', 'ca'] },
    fields: ['address_components', 'geometry'],
    types: ['address'],
};
var PAC_CONTAINER_Z_INDEX = 1500;
var PAC_STYLE_ID = 'places-above-modal';
var liftSuggestionsAboveModals = function () {
    if (typeof document === 'undefined' || document.getElementById(PAC_STYLE_ID)) {
        return;
    }
    var style = document.createElement('style');
    style.id = PAC_STYLE_ID;
    style.textContent = ".pac-container { z-index: ".concat(PAC_CONTAINER_Z_INDEX, " !important; }");
    document.head.appendChild(style);
};
export var attachAutocomplete = function (input, onPlaceSelected) {
    var _a, _b, _c;
    var Autocomplete = (_c = (_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.places) === null || _c === void 0 ? void 0 : _c.Autocomplete;
    if (!Autocomplete || isKeyRejected) {
        return null;
    }
    liftSuggestionsAboveModals();
    var autocomplete = new Autocomplete(input, AUTOCOMPLETE_OPTIONS);
    autocomplete.addListener('place_changed', function () { return onPlaceSelected(autocomplete.getPlace()); });
    var detach = function () {
        var _a, _b, _c;
        (_c = (_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.clearInstanceListeners(autocomplete);
        attachedDetachers.delete(detach);
    };
    attachedDetachers.add(detach);
    return detach;
};
var PORTAL_COUNTRY_BY_ISO_CODE = { US: 'USA', CA: 'CAN' };
export var buildAddressAutofillValues = function (place, targets) {
    var components = place === null || place === void 0 ? void 0 : place.address_components;
    if (!(components === null || components === void 0 ? void 0 : components.length)) {
        return null;
    }
    var streetParts = [];
    var picked = {};
    components.forEach(function (_a) {
        var _b;
        var _c = _a.long_name, long_name = _c === void 0 ? '' : _c, _d = _a.short_name, short_name = _d === void 0 ? '' : _d, _e = _a.types, types = _e === void 0 ? [] : _e;
        switch (types.find(function (type) { return type !== 'political'; })) {
            case 'street_number':
            case 'route':
                streetParts.push(long_name);
                break;
            case 'locality':
                picked.city = long_name;
                break;
            case 'sublocality':
                picked.city = picked.city || long_name;
                break;
            case 'administrative_area_level_1':
                picked.state = short_name;
                break;
            case 'country':
                picked.country = (_b = PORTAL_COUNTRY_BY_ISO_CODE[short_name]) !== null && _b !== void 0 ? _b : '';
                break;
            case 'postal_code':
                picked.postalCode = long_name;
                break;
            default:
                break;
        }
    });
    picked.address = streetParts.join(' ').trim();
    return Object.keys(targets).reduce(function (values, role) {
        var _a;
        var fieldName = targets[role];
        if (fieldName) {
            values[fieldName] = (_a = picked[role]) !== null && _a !== void 0 ? _a : '';
        }
        return values;
    }, {});
};
